// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__27rEJ","right":"Footer_right__177QW","buttons":"Footer_buttons__3W1sC"};